import React, { createContext, useContext, useState, useCallback } from 'react';

const BreadcrumbContext = createContext();

const MAX_TRAIL = 20; // Hard cap on breadcrumb depth

export function BreadcrumbProvider({ children }) {
  // trail is an array of { path, label, key }
  const [trail, setTrail] = useState([]);

  const pushCrumb = useCallback((path, label) => {
    setTrail((prev) => {
      // If navigating to Search, reset the trail
      if (path === '/' || path === '/search') {
        return [];
      }

      // If this path is already in the trail, truncate back to it (user went "back")
      const existingIndex = prev.findIndex((c) => c.path === path);
      if (existingIndex !== -1) {
        return prev.slice(0, existingIndex + 1);
      }

      // Otherwise append
      const next = [...prev, { path, label, key: `${path}-${Date.now()}` }];
      // Enforce hard cap — drop oldest (after Search) if too long
      if (next.length > MAX_TRAIL) {
        return next.slice(next.length - MAX_TRAIL);
      }
      return next;
    });
  }, []);

  const resetTrail = useCallback(() => {
    setTrail([]);
  }, []);

  return (
    <BreadcrumbContext.Provider value={{ trail, pushCrumb, resetTrail }}>
      {children}
    </BreadcrumbContext.Provider>
  );
}

export function useBreadcrumbs() {
  return useContext(BreadcrumbContext);
}
